import moment from "moment";

import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { Guid } from "@/Common/Models/Guid";
import { ContactFacetType } from "@/Common/Models/Individuals/Enums/ContactFacetType";
import { GenderIdentity } from "@/Common/Models/Individuals/Enums/GenderIdentity";
import { PreferredPronouns } from "@/Common/Models/Individuals/Enums/PreferredPronouns";
import { IPatientDemographicsModel } from "@/Common/Models/Patient/UI/Profile/IPatientDemographicsModel";
import { Ethnicity } from "@/Common/Models/UI/Ethnicity";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { DateOnly } from "@/Common/Utilities/DateAndTime/DateOnly";
import { IPatientProfileDemographicsProps } from "./DemographicEdit";

class DemographicView extends React.Component<IPatientProfileDemographicsProps, any> {
    private c1Paddingtop: React.CSSProperties = { paddingTop: "5px" };
    private c1NotePaddingtop: React.CSSProperties = { paddingTop: "5px", verticalAlign: "top" };

    public render(): JSX.Element {
        return (
            <div className="scrollable patientProfileView patient-prof" data-cy="patientProfile-view">
                <div className="block separated">
                    <div className="heading">
                        <h3 className="thin-font">{cacheStore.GetString("PatientInformationLabel")}</h3>
                    </div>
                    <div className="patient-profile fxd-wdth-container">
                        <div className="tb">
                            {this.leftSide(this.props.model)}
                            {this.rightSide(this.props.model)}
                        </div>
                    </div>
                </div>
                <div className="block separated">
                    <div className="heading">
                        <h3 className="thin-font">{cacheStore.GetString("ParentsLabel")}</h3>
                    </div>
                    <div className="patient-profile fxd-wdth-container">
                        {this.RenderParents()}
                    </div>
                </div>
            </div>
        );
    }

    private RenderParents(): JSX.Element {
        let model = this.props.model;

        let fatherClickStyle: React.CSSProperties = {};
        let motherClickStyle: React.CSSProperties = {};

        let fatherContactId = model.get("FatherContactId");
        let fatherContactFacetType = model.get("FatherContactFacetType");
        let motherContactId = model.get("MotherContactId");
        let motherContactFacetType = model.get("MotherContactFacetType");

        if (fatherContactId && fatherContactFacetType) {
            fatherClickStyle = { color: "#0a5bad", textDecoration: "underline", cursor: "pointer" };
        }
        if (motherContactId && motherContactFacetType) {
            motherClickStyle = { color: "#0a5bad", textDecoration: "underline", cursor: "pointer" };
        }

        return (
            <div className="tb">
                <div className="tbc left">
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="c1"><label className="form-label">{cacheStore.GetString("MotherLastNameLabel")}</label></td>
                                    <td className="c2">
                                        <div onClick={() => this.onParentClick(motherContactId, motherContactFacetType)} style={motherClickStyle}>
                                            <strong data-cy="patientProfile-parents-mothersLastName">{MyleHelper.ReplaceEmptyString((model.get("MothersLastName")))}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="c1"><label className="form-label">{cacheStore.GetString("MotherFirstNameLabel")}</label></td>
                                    <td className="c2">
                                        <div onClick={() => this.onParentClick(motherContactId, motherContactFacetType)} style={motherClickStyle}>
                                            <strong data-cy="patientProfile-parents-mothersFirstName">{MyleHelper.ReplaceEmptyString((model.get("MothersFirstName")))}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="tbc left">
                    <div>
                        <table>
                            <tbody>
                                <tr>
                                    <td className="c1"><label className="form-label">{cacheStore.GetString("FatherLastNameLabel")}</label></td>
                                    <td className="c2">
                                        <div onClick={() => this.onParentClick(fatherContactId, fatherContactFacetType)} style={fatherClickStyle}>
                                            <strong data-cy="patientProfile-parents-fathersLastName">{MyleHelper.ReplaceEmptyString((model.get("FathersLastName")))}</strong>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="c1"><label className="form-label">{cacheStore.GetString("FatherFirstNameLabel")}</label></td>
                                    <td className="c2">
                                        <div onClick={() => this.onParentClick(fatherContactId, fatherContactFacetType)} style={fatherClickStyle}>
                                            <strong data-cy="patientProfile-parents-fathersFirstName">{MyleHelper.ReplaceEmptyString((model.get("FathersFirstName")))}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    private leftSide(model: IPatientDemographicsModel): JSX.Element {
        return (
            <div className="tbc left">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PrefixLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-prefix">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedPrefixLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("FirstNameLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-firstName">{MyleHelper.ReplaceEmptyString((model.get("FirstName")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("LastNameLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-lastName">{MyleHelper.ReplaceEmptyString((model.get("LastName")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MiddleNameLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-middleName">{MyleHelper.ReplaceEmptyString((model.get("MiddleName")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PreferredNameLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-preferredName">{MyleHelper.ReplaceEmptyString((model.get("PreferredName")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SuffixLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-suffix">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedSuffixLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PreferredPronounsLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-preferredPronouns">{MyleHelper.ReplaceEmptyString(cacheStore.GetString(model.get("PreferredPronouns") ? `Enums_PreferredPronouns_${PreferredPronouns[model.get("PreferredPronouns")]}` : ""))}</strong></td>
                            </tr>
                            {model.get("PreferredPronouns") == PreferredPronouns.Other && (
                                <tr>
                                    <td />
                                    <td className="c2"><strong data-cy="patientProfile-patientInfo-ssn">{MyleHelper.ReplaceEmptyString(model.get("SpecifiedPreferredPronouns"))}</strong></td>
                                </tr>
                            )}
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SocialInsuranceNumberLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-ssn">{MyleHelper.ReplaceEmptyString((model.get("SocialInsuranceNumber")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("SexAtBirthLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-sexAtBirth">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedGenderLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("GenderIdentityLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-genderIdentity">{MyleHelper.ReplaceEmptyString(cacheStore.GetString(model.get("GenderIdentity") ? `Enums_GenderIdentity_${GenderIdentity[model.get("GenderIdentity")]}` : ""))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("EthnicityLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-ethnicity">{MyleHelper.ReplaceEmptyString(Ethnicity.selectedLabelsOf(model.get("SelectedEthnicityKeys")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("DateofBirthLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-dt">{MyleHelper.ReplaceEmptyString(model.get("DateOfBirth") == null ? "" : new DateOnly(model.get("DateOfBirth")).toString())}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("ReligionLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-religions">{MyleHelper.ReplaceEmptyString((model.get("Religion") != null ? model.get("Religion").getName() : ""))}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    private rightSide(model: IPatientDemographicsModel): JSX.Element {
        return (
            <div className="tbc right">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("MaritalStatusDLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-legalStatus">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedLegalStatusLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PreferredOfficialLanguageLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-officialLanguage">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedOfficialLanguageLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PreferredSpokenLanguageLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-spokenLanguage">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedSpokenLanguageLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PatientStatusLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-patientStatus">{MyleHelper.ReplaceEmptyString(cacheStore.GetLocalizedValueByLookupId(model.get("SelectedPatientStatusLookupId")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("PatientStatusDateLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-patientStatus-dt">{MyleHelper.ReplaceEmptyString(model.get("PatientStatusDate") == null ? "" : moment(model.get("PatientStatusDate")).format("YYYY-MM-DD"))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("ProfessionLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-profession">{MyleHelper.ReplaceEmptyString((model.get("Profession")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1Paddingtop}><label className="form-label">{cacheStore.GetString("EmployerLabel")}</label></td>
                                <td className="c2"><strong data-cy="patientProfile-patientInfo-employer">{MyleHelper.ReplaceEmptyString((model.get("Employer")))}</strong></td>
                            </tr>
                            <tr>
                                <td className="c1" style={this.c1NotePaddingtop}><label className="form-label">{cacheStore.GetString("NotesLabel")}</label></td>
                                <td className="c2">
                                    <strong className="note-wrap" data-cy="patientProfile-patientInfo-notes">{JSXHelper.BreakStringIntoParagraphs(model.get("Notes"))}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    private onParentClick(contactId: Guid, contactFacetType: ContactFacetType): void {
        sessionStore.dispatch(LocalOperations.Person.LoadFile, { contactId: contactId, contactFacetType: contactFacetType }, 0);
    }
}

export { DemographicView };
